<template>
  <div class="exam-info" v-loading="loadingData">
    <div class="title">考试事项</div>
    <div class="content">
      <div class="row">
        <div class="left">考试专业</div>
        <div class="right">{{ examInfo.majorName }}</div>
      </div>
      <div class="row">
        <div class="left">题目数量</div>
        <div class="right">{{ examInfo.questionNum }}</div>
      </div>
      <div class="row">
        <div class="left">考试时间</div>
        <div class="right">{{ examInfo.formalTestDuration }}分钟</div>
      </div>
      <div class="row">
        <div class="left">分数占比</div>
        <div class="right">{{ examInfo.learnScoreProportion }}%</div>
      </div>
      <div class="tips">
        <div class="tips-title">
          <span class="icon">i</span><span class="tt">注意事项</span>
        </div>
        <div class="tips-content" v-html="examInfo.testAttention"></div>
      </div>
    </div>
    <div
      class="start-btn"
      :class="{ 'disabled-btn': examLeftDays !== 0 }"
      @click="go2FormalExamPage"
    >
      {{
        examLeftDays === -2
          ? "暂无考试"
          : examLeftDays === -1
          ? "考试已结束"
          : examLeftDays > 0
          ? "考试未开始"
          : "开始考试"
      }}
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      examInfo: {
        examEndTime: "2000-01-01 00:00:00",
        examStartTime: "2000-01-01 00:00:00",
        formalTestDuration: 60, // 分钟
        learnScoreProportion: "50.0",
        name: "暂无考试",
        majorName: "暂无专业",
        questionNum: 0,
        testAttention: "暂无信息"
      },
      loadingData: true,
      examLeftDays: -2 // 距离考试的天数，-2：错误信息，-1：已结束，0：进行中；>0：实际天数
    };
  },
  created: function() {
    // 加载信息，确认
    this.loadExamInfo();
  },
  methods: {
    async loadExamInfo() {
      // 先加载考试信息，判断用户是否合法进入该地址
      let res = await httpRequest("/app/exam/exam", "get", null);
      if (res !== null && res !== undefined && res.code === 200) {
        const examFullInfo = res.data;
        if (examFullInfo.apply !== null && examFullInfo.apply !== undefined) {
          // 计算距离考试还有多久
          const now = new Date();
          const examStartTime = new Date(examFullInfo.exam.examStartTime);
          this.examLeftDays = Math.ceil(
            (examStartTime - now) / (1000 * 3600 * 24)
          );
          if (this.examLeftDays < 0) {
            // 已经开始考试了，判断是否已经结束了
            const examEndTime = new Date(examFullInfo.exam.examEndTime);
            const examEndLeftDays = Math.ceil(
              (examEndTime - now) / (1000 * 3600 * 24)
            );
            if (examEndLeftDays < 0) {
              this.examLeftDays = -1; // 表示已经结束了
            } else {
              this.examLeftDays = 0; // 表示进行中
            }
          }

          res = await httpRequest("/app/formal-test/notice", "get", null);
          if (res !== null && res !== undefined && res.code === 200) {
            this.examInfo = res.data;
          }
        }
      }
      this.loadingData = false;
    },
    go2FormalExamPage() {
      this.$router.push({ path: "/formalExam" });
    }
  }
};
</script>

<style scoped lang="scss">
.exam-info {
  width: 100%;
  min-height: calc(100vh - 67px - 100px - 40px);
  background: #ffffff;
  padding-bottom: 20px;
  .title {
    height: 65px;
    line-height: 65px;
    background: rgba(0, 176, 171, 1);
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    margin-top: 40px;
  }
  .content {
    padding-top: 27px;
    .row {
      margin-top: 13px;
      div {
        display: inline-block;
        height: 25px;
        line-height: 25px;
        font-size: 18px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: rgba(72, 72, 72, 1);
      }
      .left {
        width: 50%;
        text-align: right;
      }
      .right {
        width: calc(50% - 26px);
        text-align: left;
        padding-left: 26px;
        color: rgba(0, 176, 171, 1);
      }
    }
    .tips {
      margin-top: 24px;
      font-size: 14px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: rgba(118, 118, 118, 1);
      .tips-title {
        height: 20px;
        line-height: 20px;
        .icon {
          margin-left: -70px;
          display: inline-block;
          height: 12px;
          line-height: 12px;
          width: 12px;
          border-radius: 6px;
          background: rgba(0, 176, 171, 1);
          color: #ffffff;
          font-size: 12px;
          margin-right: 5px;
          vertical-align: middle;
        }
        .tt {
          vertical-align: middle;
        }
      }
      .tips-content {
        width: 500px;
        margin: 10px auto;
      }
    }
  }
  .start-btn {
    margin-top: 40px;
    margin-right: auto;
    margin-left: auto;
    height: 44px;
    line-height: 44px;
    width: 458px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    background: rgba(0, 176, 171, 1);
    border-radius: 4px;
    cursor: pointer;
  }
  .disabled-btn {
    color: #bcbec2;
    background-color: #f4f4f5;
    border-color: #e9e9eb;
    cursor: not-allowed;
  }
}
</style>
